import { Button, Text } from '@consumidor-positivo/aurora';

import { MMUpdateFilterProps } from '../../../types';
import { benefitList } from './data';
import './style.scss';

type BenefitFilterProps = {
  selectedBenefit: string;
  onChangeFilter: (filters: MMUpdateFilterProps) => void;
  clearForm: () => void;
};

export const BenefitsFilter = ({ onChangeFilter, clearForm, selectedBenefit }: BenefitFilterProps) => {
  function onClick(value: 'both' | 'miles' | 'cashback' | 'clear') {
    if (value === 'clear') {
      return clearForm();
    }

    onChangeFilter({ benefit: value });
  }

  return (
    <div className="mm-benefits-filter">
      <Text as="h3" variant="heading-small" variantDesk="heading-medium" weight="bold">
        Não encontrou o seu cartão ideal? Temos algumas dicas
      </Text>
      <div className="mm-benefits-filter__list">
        {benefitList
          .filter((item) => item.slug !== selectedBenefit)
          .map((item) => (
            <div className="mm-benefits-filter__item" key={item.slug}>
              <div className="mm-benefits-filter__item-icon">{item.icon}</div>
              <div className="mm-benefits-filter__item-texts">
                {item.title}
                {item.description}
              </div>
              <Button type="outlined" expand="x" onClick={() => onClick(item.slug)}>
                {item.buttonText}
              </Button>
            </div>
          ))}
      </div>
    </div>
  );
};
